export default __webpack_public_path__ + "static/media/Isolation_Mode.e2c3100a.svg";